import type { FaireProductEntity } from "../../entity_types/product";

export const sweet_wink_16: FaireProductEntity = {
  token: "sweet-wink-16",
  type: "product",
  name: "Flocked Heart Valentine's Day Cape - Kids Dress Up Cape",
  brandName: "Sweet Wink",
  imageUrl:
    "https://cdn.faire.com/fastly/21a696e9c91a70265b422484ff96174718513abc5a417c454e5cbbe4b57c2628.jpeg?bg-color=FFFFFF&dpr=1&fit=crop&format=jpg&height=720&precrop=1199,1199,x0,y0,safe&width=720",
  priceDollars: 18,
  msrpDollars: 36,
  freeShipping: false,
  isBestseller: false,
  description: "",
  categoryTokens: ["cat_kids-all"],
  tags: [],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-products-migration",
  },
};
